module.exports = __webpack_public_path__ + "img/advantage3@2x.49832281.png";